/**
 * Location slice — state for single-location CRUD. Note that the map does
 * NOT read locations from here: they live inside the opened zone
 * (state.zone.item.locations). `locationUpdated` carries the last edit so
 * the zone slice can patch it in via updateLocationInsideZone.
 */
import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

import {
  doCreateLocation,
  doUpdateLocation,
  doDetailLocation,
  doDeleteLocation,
} from "./thunk";

const locationsAdapter = createEntityAdapter({
  selectId: (item) => item._id,
  sortComparer: (a, b) => b.createdAt.localeCompare(a.createdAt),
});

const locationSlice = createSlice({
  name: "location",
  initialState: {
    isFetching: false,
    status: "idle",
    metadata: {},
    entities: [],
    locationUpdated: null,
    item: null,
    ids: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doCreateLocation.pending, (state) => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doCreateLocation.fulfilled, (state, action) => {
      state.isFetching = false;
      state.status = "succeeded";
    });
    builder.addCase(doCreateLocation.rejected, (state) => {
      state.isFetching = false;
      state.status = "failed";
    });
    builder.addCase(doUpdateLocation.pending, (state) => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doUpdateLocation.fulfilled, (state, action) => {
      state.isFetching = false;
      state.locationUpdated = action.payload;
      state.status = "succeeded";
    });
    builder.addCase(doUpdateLocation.rejected, (state) => {
      state.isFetching = false;
      state.status = "failed";
    });
    builder.addCase(doDetailLocation.pending, (state) => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doDetailLocation.fulfilled, (state, action) => {
      state.isFetching = false;
      state.status = "succeeded";
      state.item = action.payload;
    });
    builder.addCase(doDetailLocation.rejected, (state) => {
      state.isFetching = false;
      state.status = "failed";
    });
    builder.addCase(doDeleteLocation.pending, (state) => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doDeleteLocation.fulfilled, (state, action) => {
      state.isFetching = false;
      state.status = "succeeded";
      state.message = action.payload.message;
    });
    builder.addCase(doDeleteLocation.rejected, (state) => {
      state.isFetching = false;
      state.status = "failed";
    });
  },
});

export const {
  selectAll: selectAllLocations,
  selectById: selectLocationById,
  selectIds: selectLocationIds,
} = locationsAdapter.getSelectors((state) => state.location);

const { reducer: locationReducer } = locationSlice;
export default locationReducer;
